import React from "react";
import { Box } from "@material-ui/core";
import PageLayout from "../../layouts/PageLayout";

const NotFoundPage = (): JSX.Element => (
  <PageLayout>
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      minHeight={300}
    >
      <span>Nothing here</span>
    </Box>
  </PageLayout>
);

export default NotFoundPage;
